import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import CommonPage from '@/components/CommonPage';
import CommonPageOld from '@/components/CommonPageOld';
import CommonPostDetail from '@/components/CommonPostDetail';
import DiscussionAddForm from '@/components/DiscussionAddForm';
import AttachmentAddForm from '@/components/AttachmentAddForm';
import AddEditMenu from '@/components/AddEditMenu';
import EventAddForm from '@/components/EventAddForm';
//import UserList from '@/components/UserList';
import AddCalendarKey from '@/components/AddCalendarKey';
import AddAttachmentGroup from '@/components/AddAttachmentGroup';
import ListCalendarKey from '@/components/ListCalendarKey';
import ListAttachmentGroup from '@/components/ListAttachmentGroup';

import UserList from '@/components/backend/user/ListUser';
import ChangeProfile from '@/components/backend/user/ChangeProfile';
import AddUpdateUsers from '@/components/backend/user/AddUpdateUsers';
import HRDragView from '@/components/backend/user/HRDragView';

import ListROReversalRequest from '@/components/Forms/ROReversalRequest/ListROReversalRequest';
import AddUpdateROReversalRequest from '@/components/Forms/ROReversalRequest/AddUpdateROReversalRequest';

import ListTechTime from '@/components/Forms/TechTimeMaster/ListTechTime';
import AddUpdateTechTime from '@/components/Forms/TechTimeMaster/AddUpdateTechTime';

import ListContinuousImprovementSugg from '@/components/Forms/ContinuousImprovementSuggestions/ListContinuousImprovementSugg';
import AddUpdateContinuousImprovementSugg from '@/components/Forms/ContinuousImprovementSuggestions/AddUpdateContinuousImprovementSugg';

import ListUniformRequestForm from '@/components/Forms/UniformRequest/ListUniformRequestForm';
import AddUpdateUniformRequestForm from '@/components/Forms/UniformRequest/AddUpdateUniformRequestForm';

import ListFormEmailManager from '@/components/Forms/FormEmailManager/ListFormEmailManager';
import AddUpdateFormEmailManager from '@/components/Forms/FormEmailManager/AddUpdateFormEmailManager';

import PageNotFound from '@/components/PageNotFound';
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
            // component: () => import('@/components/Login.vue')
        },
        {
            path: '/user/list',
            name: 'UserList',
            component: UserList,
            // component: () => import('@/components/backend/user/ListUser')
        },
        {
            path: '/changeprofile',
            name: 'ChangeProfile',
            component: ChangeProfile,
            // component: () => import('@/components/backend/user/ChangeProfile')
        },
        {
            path: '/updateusers/:id',
            name: 'AddUpdateUsers',
            component: AddUpdateUsers,
            // component: () => import('@/components/backend/user/AddUpdateUsers')
        },
        {
            path: '/roreversal/list',
            name: 'ListROReversalRequest',
            component: ListROReversalRequest,
            // component: () => import('@/components/Forms/ROReversalRequest/ListROReversalRequest')
        },
        {
            path: '/roreversal/add',
            name: 'AddUpdateROReversalRequest',
            component: AddUpdateROReversalRequest,
            // component: () => import('@/components/Forms/ROReversalRequest/AddUpdateROReversalRequest')
        },
        {
            path: '/roreversal/edit/:id',
            name: 'UpdateROReversalRequest',
            component: AddUpdateROReversalRequest,
            // component: () => import('@/components/Forms/ROReversalRequest/AddUpdateROReversalRequest')
        },
        {
            path: '/techtime/list',
            name: 'ListTechTime',
            component: ListTechTime,
            // component: () => import('@/components/Forms/TechTimeMaster/ListTechTime')
        },
        {
            path: '/techtime/add',
            name: 'AddUpdateTechTime',
            component: AddUpdateTechTime,
            // component: () => import('@/components/Forms/TechTimeMaster/AddUpdateTechTime')
        },
        {
            path: '/continuous/improvement/suggestions/list',
            name: 'ListContinuousImprovementSugg',
            component: ListContinuousImprovementSugg,
            // component: () => import('@/components/Forms/ContinuousImprovementSuggestions/ListContinuousImprovementSugg')
        },
        {
            path: '/continuous/improvement/suggestions/add',
            name: 'AddUpdateContinuousImprovementSugg',
            component: AddUpdateContinuousImprovementSugg,
            // component: () => import('@/components/Forms/ContinuousImprovementSuggestions/AddUpdateContinuousImprovementSugg')
        },
        {
            path: '/continuous/improvement/suggestions/edit/:id',
            name: 'UpdateContinuousImprovementSugg',
            component: AddUpdateContinuousImprovementSugg,
            // component: () => import('@/components/Forms/ContinuousImprovementSuggestions/AddUpdateContinuousImprovementSugg')
        },
        {
            path: '/hrdragview',
            name: 'HRDragView',
            component: HRDragView,
            // component: () => import('@/components/backend/user/HRDragView')
        },
        {
            path: '/:type',
            name: 'CommonPage',
            component: CommonPage
            // component: () => import('@/components/CommonPage')
        },{
            path: '/:type/test',
            name: 'CommonPageOld',
            component: CommonPageOld
            // component: () => import('@/components/CommonPageOld')
        },
        {
            path: '/:type/view',
            name: 'CommonPostDetail',
            component: CommonPostDetail
            // component: () => import('@/components/CommonPostDetail')
        },
        {
            path: '/:type/add_post',
            name: 'DiscussionAddForm',
            component: DiscussionAddForm
            // component: () => import('@/components/DiscussionAddForm')
        },
        {
            path: '/:type/edit_post/:id',
            name: 'DiscussionEditForm',
            component: DiscussionAddForm
            // component: () => import('@/components/DiscussionAddForm')
        },
        {
            path: '/:type/add_attachment',
            name: 'AttachmentAddForm',
            component: AttachmentAddForm
            // component: () => import('@/components/AttachmentAddForm')
        },
        {
            path: '/:type/edit_attachment/:id',
            name: 'AttachmentEditForm',
            component: AttachmentAddForm
            // component: () => import('@/components/AttachmentAddForm')
        },
        {
            path: '/:type/add_date',
            name: 'EventAddForm',
            component: EventAddForm
            // component: () => import('@/components/EventAddForm')
        },
        {
            path: '/:type/edit_date/:id',
            name: 'EventEditForm',
            component: EventAddForm
            // component: () => import('@/components/EventAddForm')
        },
        {
            path: '/menu/add-edit-menu',
            name: 'AddEditMenu',
            component: AddEditMenu
            // component: () => import('@/components/AddEditMenu')
        },
        /*{
            path: '/user/list',
            name: 'UserList',
            component: UserList
        },*/
        {
            path: '/key/list',
            name: 'ListCalendarKey',
            component: ListCalendarKey
            // component: () => import('@/components/ListCalendarKey')
        },
        {
            path: '/key/add',
            name: 'AddCalendarKey',
            component: AddCalendarKey
            // component: () => import('@/components/AddCalendarKey')
        },
        {
            path: '/key/edit/:id',
            name: 'EditCalendarKey',
            component: AddCalendarKey
            // component: () => import('@/components/AddCalendarKey')
        },
        {
            path: '/attachment-group/list',
            name: 'ListAttachmentGroup',
            component: ListAttachmentGroup
            // component: () => import('@/components/ListAttachmentGroup')
        },
        {
            path: '/attachment-group/add',
            name: 'AddAttachmentGroup',
            component: AddAttachmentGroup
            // component: () => import('@/components/AddAttachmentGroup')
        },
        {
            path: '/attachment-group/edit/:id',
            name: 'EditAttachmentGroup',
            component: AddAttachmentGroup
            // component: () => import('@/components/AddAttachmentGroup')
        },
        {
            path: '/uniform/request/list',
            name: 'ListUniformRequestForm',
            component: ListUniformRequestForm,
            // component: () => import('@/components/Forms/UniformRequest/ListUniformRequestForm')
        },
        {
            path: '/uniform/request/add',
            name: 'AddUpdateUniformRequestForm',
            component: AddUpdateUniformRequestForm,
            // component: () => import('@/components/Forms/UniformRequest/AddUpdateUniformRequestForm')
        },
        {
            path: '/form/email/manager/list',
            name: 'ListFormEmailManager',
            component: ListFormEmailManager,
            // component: () => import('@/components/Forms/FormEmailManager/ListFormEmailManager')
        },
        {
            path: '/form/email/manager/add',
            name: 'AddUpdateFormEmailManager',
            component: AddUpdateFormEmailManager,
            // component: () => import('@/components/Forms/FormEmailManager/AddUpdateFormEmailManager')
        },
        {
            path: '/form/email/manager/edit/:id',
            name: 'UpdateFormEmailManager',
            component: AddUpdateFormEmailManager,
            // component: () => import('@/components/Forms/FormEmailManager/AddUpdateFormEmailManager')
        },
        {
            path: '*',
            name: 'PageNotFound',
            component: PageNotFound
        }
    ]
});
